import { World2 as o } from "./world-2.js";
import { Globe2 as r } from "./globe-2.js";
import { Global as m } from "./global.js";
import { LocalPaymentMethods as i } from "./local-payment-methods.js";
import { Bank as t } from "./bank.js";
import { Company as p } from "./company.js";
import { FoundedFlag as f } from "./founded-flag.js";
import { Headquarters as e } from "./headquarters.js";
import { Location as a } from "./location.js";
import { LpmApac as l } from "./lpm-apac.js";
import { LpmEmea as n } from "./lpm-emea.js";
import { LpmLatam as d } from "./lpm-latam.js";
import { LpmUs as c } from "./lpm-us.js";
import { Pointer as s } from "./pointer.js";
import { Store as L } from "./store.js";
import { Store2 as u } from "./store-2.js";
import { Windmill as W } from "./windmill.js";
import { Berlin as B } from "./berlin.js";
import { Boat as h } from "./boat.js";
import { Bus as A } from "./bus.js";
import { Bus2 as g } from "./bus-2.js";
import { Delivery as k } from "./delivery.js";
import { Door as y } from "./door.js";
import { House as P } from "./house.js";
import { House2 as b } from "./house-2.js";
import { Lighthouse as x } from "./lighthouse.js";
import { London as E } from "./london.js";
import { MilanCathedral as G } from "./milan-cathedral.js";
import { ParisEiffel as M } from "./paris-eiffel.js";
import { Rollerskate as D } from "./rollerskate.js";
import { Singapore as F } from "./singapore.js";
import { Taxi as H } from "./taxi.js";
import { Truck as S } from "./truck.js";
import { UnitedKingdom as T } from "./united-kingdom.js";
import { BicycleParking as C } from "./bicycle-parking.js";
import { Biycle as N } from "./biycle.js";
import { Direction as R } from "./direction.js";
import { GlobalRefresh as U } from "./global-refresh.js";
import { Globe as q } from "./globe.js";
import { Mexico as v } from "./mexico.js";
import { NetworkFix as w } from "./network-fix.js";
import { World as K } from "./world.js";
import { WorldAfrica as j } from "./world-africa.js";
import { WorldAsiaPacific as z } from "./world-asia-pacific.js";
import { WorldEurope as I } from "./world-europe.js";
import { WorldLatinAmerica as J } from "./world-latin-america.js";
import { WorldMiddleEast as O } from "./world-middle-east.js";
import { WorldNorthAmerica as Q } from "./world-north-america.js";
const zo = {
  World2: o,
  Globe2: r,
  Global: m,
  LocalPaymentMethods: i,
  Bank: t,
  Company: p,
  FoundedFlag: f,
  Headquarters: e,
  Location: a,
  LpmApac: l,
  LpmEmea: n,
  LpmLatam: d,
  LpmUs: c,
  Pointer: s,
  Store: L,
  Store2: u,
  Windmill: W,
  Berlin: B,
  Boat: h,
  Bus: A,
  Bus2: g,
  Delivery: k,
  Door: y,
  House: P,
  House2: b,
  Lighthouse: x,
  London: E,
  MilanCathedral: G,
  ParisEiffel: M,
  Rollerskate: D,
  Singapore: F,
  Taxi: H,
  Truck: S,
  UnitedKingdom: T,
  BicycleParking: C,
  Biycle: N,
  Direction: R,
  GlobalRefresh: U,
  Globe: q,
  Mexico: v,
  NetworkFix: w,
  World: K,
  WorldAfrica: j,
  WorldAsiaPacific: z,
  WorldEurope: I,
  WorldLatinAmerica: J,
  WorldMiddleEast: O,
  WorldNorthAmerica: Q
};
export {
  zo as LocationsAndTransport
};
